export function debounce(fn: any, duration: any) {
  let timer: any = null;
  return function (...args: any) {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      //@ts-ignore
      fn.apply(this, args);
    }, duration);
  };
}
export function generateYears(startYear:number=2023) {
  const currentYear = new Date().getFullYear(); // Get the current year
  const yearsList = [];

  // Generate years from startYear until one year ahead of current year
  for (let year = startYear; year <= currentYear + 1; year++) {
    yearsList.push({ label: year.toString(), value: year.toString() });
  }

  return yearsList;
}
